// store/modules/globalModule.js
import {defaultCurrencySettings} from "../../../configs/currencySettings";

export const globalModule = {
    namespaced: true,
    state() {
        return {
            selectedCurrency: null,
        };
    },
    mutations: {
        setCurrency(state, currency) {
            state.selectedCurrency = currency;
        }
    },
    actions: {
        updateCurrency({ commit }, currency) {
            commit('setCurrency', currency);
        }
    },
    getters: {
        getCurrency(state) {
            return state.selectedCurrency || defaultCurrencySettings;
        }
    }
};
